// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_it-6";
export var emphasizeQuantity = "_it-3";
export var flatBottomCorners = "_it-5";
export var productImage = "_it-0";
export var quantityContainer = "_it-2";
export var tooltip = "_it-1";
export var wrapAndEllipsesOverflow = "_it-4";